import { msg } from '~/utils/validation';
import { z } from 'zod';

export const schema = z.object({
  club: z.tuple([z.string(), z.number()], { message: msg.required }),
  start_date: z.string({ message: msg.required }),
  end_date: z.string().optional(),
});

export type Schema = z.infer<typeof schema>;
